var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalls = function SvgCalls(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_call",
    transform: "translate(-18 -87)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bound",
    width: 22,
    height: 22,
    transform: "translate(18 87)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "call_FILL0_wght300_GRAD-25_opsz20",
    d: "M163.069-796.767a12.421,12.421,0,0,1-5.465-1.3,17.734,17.734,0,0,1-4.82-3.424,17.653,17.653,0,0,1-3.436-4.805,12.348,12.348,0,0,1-1.308-5.46.915.915,0,0,1,.3-.683.971.971,0,0,1,.7-.285h3.1a.936.936,0,0,1,.637.221,1.009,1.009,0,0,1,.327.586l.6,2.831a1.147,1.147,0,0,1-.03.575,1.025,1.025,0,0,1-.288.45l-2.165,2.151a15.911,15.911,0,0,0,2.577,3.382,17.325,17.325,0,0,0,3.525,2.711l2.174-2.239a1.159,1.159,0,0,1,.45-.309,1.1,1.1,0,0,1,.513,0l2.762.573a.953.953,0,0,1,.6.329.965.965,0,0,1,.231.646v3.066a.973.973,0,0,1-.284.7A.918.918,0,0,1,163.069-796.767Zm-12.562-10.515,1.648-1.577a.183.183,0,0,0,.056-.1.264.264,0,0,0,0-.12l-.431-2.055a.2.2,0,0,0-.065-.111.187.187,0,0,0-.12-.037h-1.929a.124.124,0,0,0-.095.037.13.13,0,0,0-.035.093,10.22,10.22,0,0,0,.3,1.914A12.939,12.939,0,0,0,150.507-807.282Zm11.958,9.04a.126.126,0,0,0,.093-.037.126.126,0,0,0,.037-.093V-800.3a.187.187,0,0,0-.037-.12.2.2,0,0,0-.111-.065l-1.937-.424a.173.173,0,0,0-.1,0,.258.258,0,0,0-.088.056l-1.647,1.7a10.752,10.752,0,0,0,1.924.611A17.5,17.5,0,0,0,162.465-798.242ZM158.656-799.141ZM150.507-807.282Z",
    transform: "translate(-127.04 902.748)",
    fill: "#8d8d8d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalls, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calls.21786947.svg";
export { ForwardRef as ReactComponent };